module.exports = __webpack_public_path__ + "images/other.a85bd87a9a5578bdaad2874f9d919fac.svg";